import ClientAgent from '../clientAgent'

let clientAgent = new ClientAgent()
let allGrantedPermissions = []

export default {
  methods: {
    /**
     * @param {Array} permissionsArray
     * @returns {Promise<unknown>}
     */
    retrievePermissions (permissionsArray = []) {
      return new Promise((resolve, reject) => {
        let param = []
        for (let i = 0; i < permissionsArray.length; i++) {
          param.push('permissions[]=' + permissionsArray[i])
        }
        /* poberemo vse unikatne permissione iz routes na željo Senior Full Stack Software Arhitekta in Skrbnika Aplikacij */
        clientAgent.postPromise(
          'permissions/all',
          param).then((result) => {
          allGrantedPermissions = result.results
          if (typeof allGrantedPermissions === 'undefined' || allGrantedPermissions === null) {
            allGrantedPermissions = []
          }
          resolve(allGrantedPermissions)
        }).catch((err) => {
          reject(err)
        })
      })
    },
    /**
     * @returns {Array}
     */
    getAllGrantedPermissions () {
      return allGrantedPermissions
    },
    /**
     * @param {String} permissionId
     * @param {Boolean} additionalDataRequired
     * @param {String} fieldKey
     * @param {String|Number} fieldValue
     * @returns {Boolean}
     */
    HasPermission (permissionId, additionalDataRequired = false, fieldKey = null,
      fieldValue = null) {
      let checkAdditionalData = (additionalDataRequired === true || (fieldKey !== null && fieldValue !== null))
      if (typeof allGrantedPermissions[permissionId] === 'undefined') {
        return false
      }
      let perm = allGrantedPermissions[permissionId]
      if (perm.hasPermission === false) {
        return false
      }
      if (checkAdditionalData === true && (perm.additionalData === null || perm.additionalData.length === 0)) {
        return false
      }
      if (fieldKey !== null && fieldValue !== null) {
        return this.FindValueInAdditionalData(perm.additionalData, fieldKey, fieldValue)
      }
      return true
    },
    FindValueInAdditionalData (data, key, value) {
      if (typeof data === 'undefined' || data === null) {
        return false
      }
      if (typeof value === 'undefined' || value === null) {
        return false
      }
      let retValue = false
      data.forEach(function (dataObj) {
        if (key in dataObj && dataObj[key] === value) {
          retValue = true
        }
      })
      return retValue
    },
    /**
     * @param {String} permissionId
     * @returns {Array}
     * @constructor
     */
    GetPermissionData (permissionId) {
      if (typeof allGrantedPermissions[permissionId] === 'undefined') {
        return []
      }
      return allGrantedPermissions[permissionId].additionalData
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/Permissions/permissionHelper.js